module.exports = __webpack_public_path__ + "static/media/linkedinIcon.d5a4c28c.svg";